import alerts from "./alerts";
import buttons from "./buttons";
import header from "./header";
import headings from "./headings";
import birds from "./birds";
import marquee from "./marquee";
import mouse from "./mouse";
import language from "./language";
import mobilebar from "./mobilebar";
import packages from "./packages";
import anchornav from "./anchornav";
import images from "./images";
import cookiebottrigger from "./cookiebottrigger";
import chatbot from "./chatbot";

alerts();
buttons();
header();
headings();
birds();
marquee();
mouse();
language();
mobilebar();
packages();
anchornav();
images();
cookiebottrigger();
chatbot();
